export default "__VITE_ASSET__4do5tvMl__"